import request from '@/utils/request';
// 获取直播配置列表
const getLiveConfig = id => {
    return request({
        url: `/gathering/meeting/${id}/live`,
        method: 'get'
    });
};
// 添加直播线路
const addLiveLine = (id, params) => {
    return request({
        url: `/gathering/meeting/${id}/stream`,
        data: params,
        method: 'post'
    });
};
// 编辑线路的简单信息
const editLineInfo = (id, stream_id, params) => {
    return request({
        url: `/gathering/meeting/${id}/stream-simple/${stream_id}`,
        data: params,
        method: 'put'
    });
};
// 编辑线路全部信息
const editLineWholeInfo = (id, stream_id, params) => {
    return request({
        url: `/gathering/meeting/${id}/stream/${stream_id}`,
        data: params,
        method: 'put'
    });
};
// 删除线路全部信息
const deleteLineWholeInfo = (id, stream_id, params) => {
    return request({
        url: `/gathering/meeting/${id}/stream/${stream_id}`,
        data: params,
        method: 'delete'
    });
};
// 获取域名列表
const getDomainList = () => {
    return request({
        url: `/gathering/live/push/list`,
        method: 'get'
    });
};
// 配置会议直播
const configureMeeting = (id, ) => {
    return request({
        url: `/gathering/meeting/${id}/live`,
        method: 'put',
        data: params
    });
};
// 使用指定线路
const appointLine = (id, stream_id) => {
    return request({
        url: `/gathering/meeting/${id}/stream-using/${stream_id}`,
        method: 'put'
    });
};
// 根据会议id获取用户会议实名信息
const gatheringMeetingAuth = params  => {
    return request({
        url: `/gathering/meeting_auth/${params.meeting_id}/${params.isPc}`,
        method: 'get'
    });
};

// 创建一步签署
const gatheringMeetingAuthFlowOneStep = data => {
    return request({
        url: `/gathering/meeting_auth/flow_one_step`,
        method: 'post',
        data
    });
};
// 创建一步签署
const getPsnAuthUrl = data => {
    return request({
        url: `/gathering/meeting_auth/get_psn_auth_url`,
        method: 'post',
        data
    });
};

export {
    gatheringMeetingAuthFlowOneStep,
    gatheringMeetingAuth,
    getLiveConfig,
    getDomainList,
    configureMeeting,
    addLiveLine,
    editLineInfo,
    editLineWholeInfo,
    appointLine,
	deleteLineWholeInfo,
	getPsnAuthUrl
};
